import React from 'react'
import '../../graphStyles.scss'

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
  } from 'chart.js';
  import { Bar } from 'react-chartjs-2'
  
  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  )




/**
 * Made up data to be replaced
 */
const labels = [
    'Age (25-44)',
    'Gender (Male)',
    'State (CA, WA)',
    'Device (IOS)',
    'Day of Week (Sun)',
    'Time of Day (Afternoon)',
    'Word Group 1 (Environmentall Friendly)',
    'Word Group 2 (Traditional Razor)',
    'Word Group 3 (Platinum Coated)',
    'Word Group 4 (Super Saver Pack)'
]

const fakeConversions = [
    [10], 
    [null, 18], 
    [null, null, 25], 
    [null, null, null, 90], 
    [null, null, null, null, 72],
    [null, null, null, null, null, 60], 
    [null, null, null, null, null, null, 58], 
    [null, null, null, null, null, null, null, 62], 
    [null, null, null, null, null, null, null, null, 70], 
    [null, null, null, null, null, null, null, null, null, 45]
]






export function TopFeaturesConversionGraph({ features, conversions }) {

  // Uncomment and delete above labels array
  //const labels = features


  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
        labels: {
            filter: (l) => (l.text === 'Conversions')
        },
        onHover: function (event, legendItem) {
          document.getElementById("chart14").style.cursor = 'pointer'
        },
        onLeave: function (event, legendItem) {
          document.getElementById("chart14").style.cursor = 'default'
        },
      },

    },
    scales: {
        x: {
            title: {
                display: true,
                text: 'List of Features',
                font: {
                    size: 13.5
                }
            },
            grid: {
                display: false
            },
            stacked: true

        },
        y: {
            title: {
              display: true,
              text: 'Number of Conversions',
              font: {
                size: 13.5
              }
            }
        },   
    },
  }



  const data = {

    // Replace with weeks prop
    labels,

    datasets: [
      {
        label: 'Conversions',

        // Replace with clicks prop
        // Light blue
        data: fakeConversions[0],
        backgroundColor: 'rgba(0, 200, 248)',
      },
      {
        // Red
        data: fakeConversions[1],
        backgroundColor: 'rgba(200, 35, 60)',
      },
      {
        // Yellow
        data: fakeConversions[2],
        backgroundColor: 'rgba(250, 196, 60)',
      },
      {
        // Teal
        data: fakeConversions[3],
        backgroundColor: 'rgba(13, 155, 98)',
      },
      {
        // Orange
        data: fakeConversions[4],
        backgroundColor: 'rgba(209, 150, 98)',
      },
      {
        // Dark Blue
        data: fakeConversions[5],
        backgroundColor: 'rgba(32, 43, 165, 1)'
      },
      {
        // Pink
        data: fakeConversions[6],
        backgroundColor: 'rgba(255, 188, 207, 1)'
      },
      {
        // Blue
        data: fakeConversions[7],
        backgroundColor: 'rgba(150, 136, 255, 1)'
      },
      {
        // Green
        data: fakeConversions[8],
        backgroundColor: 'rgba(88, 204, 108, 1)'
      },
      {
        // Purple
        data: fakeConversions[9],
        backgroundColor: 'rgba(175, 100, 184, 1)'
      },
      
    ],
  }



    return (
        <div className='graph'>
            <div className='graph__title'>
                <h4>Top Important Features Based On Conversion</h4>
            </div>
            <Bar className='chart' id='chart14' options={options} data={data}/>
        </div>
    )
}
